import { useState } from 'react';
import { Header } from '@/components/ui';
import AdminSidebar from '@/components/ui/AdminSidebar';
import AuditTaskView from '@/components/audit/AuditTaskView';
import ContattiList from '@/components/data/ContattiView';
import Overview from '@/components/data/overview';
import PreferitiGrid from '@/components/data/ContattiPreferiti';
import Footer from '@/components/ui/footer';
import DaContattare from '@/components/data/DaRicontattare';

type TabType =
  | 'overview'
  | 'auditTasks'
  | 'contatti'
  | 'preferiti'
  | 'daContattare';

export default function DataView() {
  const [tabAttivo, setTabAttivo] = useState<TabType>('overview');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'auditTasks', label: 'Audit Task' },
    { id: 'contatti', label: 'Contatti' },
    { id: 'preferiti', label: 'Preferiti' },
    { id: 'daContattare', label: 'Da contattare' },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header onAdminClick={() => setSidebarOpen(true)} />
      <AdminSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Contenuto principale */}
      <div className="flex-grow mt-10 px-5">
        {/* Tabs con scroll orizzontale su schermi piccoli */}
        <div className="bg-white border border-primary/20 shadow-md rounded-lg xl:rounded-xl  mb-5 overflow-x-auto scrollbar-thin scrollbar-thumb-primary/40 scrollbar-track-transparent">
          <div className="flex md:grid md:grid-cols-5 gap-4 md:gap-2 p-2 min-w-max md:min-w-0 ">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setTabAttivo(tab.id as TabType)}
                className={`flex-shrink-0 h-8 min-w-[110px] md:min-w-0 px-3 rounded-lg cursor-pointer xl:rounded-xl flex items-center justify-center font-semibold text-md md:text-base transition duration-200 ${
                  tabAttivo === tab.id
                    ? 'bg-primary text-white font-bold shadow-sm'
                    : 'bg-white text-secondary/70 hover:bg-primary/10'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Contenuto del tab selezionato */}
        <div className="text-left text-secondary/90">
          {tabAttivo === 'auditTasks' ? (
            <AuditTaskView />
          ) : tabAttivo === 'contatti' ? (
            <ContattiList />
          ) : tabAttivo === 'preferiti' ? (
            <PreferitiGrid />
          ) : tabAttivo === 'overview' ? (
            <Overview />
          ) : (
            <DaContattare />
          )}
        </div>
      </div>

      {/* Footer sempre in fondo */}
      <Footer />
    </div>
  );
}
